define('StringSimplification',['string'],function (S) {
    return function Simplification(s,wrap){
        var simple = S((s||'').toLowerCase()).latinise().stripPunctuation().s;
        if(wrap){
            simple = '^'+simple+'$';
        }
        return simple;
    }
});
